import styled from "styled-components";

const TrackBackground = styled.div`
  border-radius: 100px;
  background-color: #f4f5f8;
  position: relative;
  width: 240px;
  padding: 10px 16px;
`;

const Track = styled.div`
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: #7020ff;
`;

const Thumb = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 100px;
  box-shadow: 0 2px 4px 0 rgba(34, 41, 57, 0.1);
  background-color: #7020ff;
  z-index: 0 !important;
  :focus {
    transform: scale(1.1);
    outline: none;
    background-color: #712de2;
  }
  :hover {
    background-color: #712de2;
  }
`;

const Label = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 240px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.14;
  color: #222939;
  margin-top: 8px;
`;

const Tooltip = styled.div`
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(34, 41, 57, 0.1);
  background-color: #7020ff;
  font-size: 10px;
  font-weight: bold;
  line-height: 1.6;
  color: #ffffff;
  position: absolute;
  top: -18px;
  padding: 0 4px;
  width: 20px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { Track, TrackBackground, Thumb, Label, Tooltip };
